import angular from 'angular';

angular.module('app.services')

    .factory('UserService', function(IoUserFactory, $q, CurrentUser) {
        var service = {};
        service.clients = null;
        service.agents = null;
        service.clients = null;
        service.client = null;
        service.userRole = null;
        service.user = null;
        service.users = null;
        service.userId = null;
        service.errors = null;

        service.adjustStickyHeader = function() {
            var parentWidth = $(".nav-content").width();
            $("#header").width(parentWidth);
            var childHeight = $("#header").height();
            $(".nav-content").height(childHeight);
        }

        service.adjustStickyHeaderWindowResize = function() {
            $(window).resize(
                function() {
                    service.adjustStickyHeader();
                }
            )
        }

        // Get all users
        service.getUsers = function(clusterId) {
            var deferred = $q.defer();
            var params = {'clusterId': clusterId};

            IoUserFactory.users().get(params).$promise.then(function(data) {
                service.users = data.users;
                deferred.resolve();
            }, function(response) {
                console.log("error getting users");
                deferred.reject();
            });

            return deferred.promise;
        };

        // Get all single user
        service.getUser = function(userId) {
            var deferred = $q.defer();
            var params = {'id': userId};

            IoUserFactory.user().get(params).$promise.then(function(data) {
                service.user = data.user;
                deferred.resolve();
            }, function(response) {
                console.log("error getting user " + userId);
                deferred.reject();
            });

            return deferred.promise;
        };

        // Get all users for a queue
        service.getUsersForQueue = function(queueId, clusterIds, queueAccess = 0) {
            var deferred = $q.defer();
            var params = {
                'queueId': queueId,
                'clusterIds': clusterIds,
                'queueAccess': queueAccess,
            };

            IoUserFactory.usersForQueue().save(params).$promise.then(function(data) {
                service.users = data.users;
                deferred.resolve(data.users);
            }, function(response) {
                console.log("error getting users for queue " + queueId);
                deferred.reject();
            });

            return deferred.promise;
        };

        // Get all users for a queue
        service.getUsersForQueues = function(queueIds, clusterIds) {
            var deferred = $q.defer();
            var params = {
                'queueIds': queueIds,
                'clusterIds': clusterIds
            };

            IoUserFactory.usersForQueues().save(params).$promise.then(function(data) {
                service.users = data.users;
                deferred.resolve();
            }, function(response) {
                console.log("error getting users for queues " + queueIds);
                deferred.reject();
            });

            return deferred.promise;
        };


        // Get all users for a cluster with a few roles
        service.getUsersForCluster = function(clusterId) {
            var deferred = $q.defer();
            var params = {
                'clusterId': clusterId
            };

            IoUserFactory.usersForCluster().get(params).$promise.then(function(data) {
                service.users = data.users;
                deferred.resolve();
            }, function(response) {
                console.log("error getting users for cluster " + clusterId);
                deferred.reject();
            });

            return deferred.promise;
        };

        // Get all client users
        service.getClients = function(clusterId) {
            var deferred = $q.defer();
            var params = {'clusterId': clusterId};

            IoUserFactory.clients().get(params).$promise.then(function(data) {
                service.clients = data.clients;
                deferred.resolve();
            }, function(response) {
                console.log("error getting client users");
                deferred.reject();
            });

            return deferred.promise;
        };

        // Get all agent users
        service.getAgents = function(clusterId) {
            var deferred = $q.defer();
            var params = {'clusterId': clusterId};

            IoUserFactory.agents().get(params).$promise.then(function(data) {
                service.agents = data.agents;
                deferred.resolve();
            }, function(response) {
                console.log("error getting agent users");
                deferred.reject();
            });

            return deferred.promise;
        };

        // Get all sales agent users
        service.getSalesAgents = function(clusterId) {
            var deferred = $q.defer();
            var params = {'clusterId': clusterId};

            IoUserFactory.salesAgents().get(params).$promise.then(function(data) {
                service.agents = data.agents;
                deferred.resolve();
            }, function(response) {
                console.log("error getting sales agent users");
                deferred.reject();
            });

            return deferred.promise;
        };

        // Get all adops agent users
        service.getAdopsAgents = function(clusterId) {
            var deferred = $q.defer();
            var params = {'clusterId': clusterId};

            IoUserFactory.adopsAgents().get(params).$promise.then(function(data) {
                service.agents = data.agents;
                deferred.resolve();
            }, function(response) {
                console.log("error getting adops agent users");
                deferred.reject();
            });

            return deferred.promise;
        };

        // Get all clients
        service.getCustomers = function(clusterId) {
            var deferred = $q.defer();
            var params = {};

            if (clusterId) {
                params.clusterId = clusterId
            }

            IoUserFactory.clients().get(params).$promise.then(function(data) {
                service.clients = data.clients;
                deferred.resolve();
            }, function(response) {
                console.log("error getting clients");
                deferred.reject();
            });

            return deferred.promise;
        };

        // Get a single client
        service.getClient = function(clientId) {
            var deferred = $q.defer();
            var params = {'id': clientId};

            IoUserFactory.client().get(params).$promise.then(function(data) {
                service.client = data.client;
                deferred.resolve();
            }, function(response) {
                console.log("error getting client " + clientId);
                deferred.reject();
            });

            return deferred.promise;
        };

        // Add a single client
        service.addClient = function(clientData) {
            var deferred = $q.defer();

            IoUserFactory.client().save(clientData).$promise.then(function(data) {
                if (data.errors) {
                    service.errors = data.errors;
                } else {
                    service.client = data.client;
                }
                deferred.resolve(data.client);
            }, function(response) {
                console.log("error adding new client");
                deferred.reject();
            });

            return deferred.promise;
        };

        // Update an existing client
        service.updateClient = function(clientData) {
            var deferred = $q.defer();

            IoUserFactory.client().update(clientData).$promise.then(function(data) {
                if (data.errors) {
                    service.errors = data.errors;
                } else {
                    service.client = data.client;
                }
                deferred.resolve();
            }, function(response) {
                console.log("error updating client");
                deferred.reject();
            });

            return deferred.promise;
        };

        //get client statuses
        service.getClientStatuses = function() {
            var deferred = $q.defer();

            IoUserFactory.clientStatuses().get().$promise.then(function(data) {
                service.reporting_statuses = data.reporting_statuses;
                service.io_statuses = data.io_statuses;
                deferred.resolve();
            }, function(response) {
                console.log("error getting client statuses ");
                deferred.reject();
            });

            return deferred.promise;
        }

        // Get the user role for the currently logged in user
        service.getCurrentUserRole = function() {
            var deferred = $q.defer();

            IoUserFactory.currentUserRole().get().$promise.then(function(data) {
                CurrentUser.set(data);
                service.userRole = data.loggedInUser;
                deferred.resolve();
            }, function(response) {
                console.log("error getting current user role");
                deferred.reject();
            });

            return deferred.promise;
        };

        // Get the user role permissions for the user
        service.getUserTaRolePermissions = function(roleId, userType, module) {
            let deferred = $q.defer();
            const params = {
                'roleId': roleId,
                'userType': userType,
                'module': module,
            }

            IoUserFactory.getUserTaRolePermissions().get(params).$promise.then(function(data) {
                CurrentUser.set(data);
                if (data.permissions) {
                    deferred.resolve(data.permissions);
                } else {
                    deferred.reject();
                }
            }, function(response) {
                console.log("error getting user role permissions");
                deferred.reject(response);
            });

            return deferred.promise;
        };

        // Get all campaign manager users
        service.getCampaignManagers = function(clusterId) {
            var deferred = $q.defer();
            var params = {'clusterId': clusterId};

            IoUserFactory.campaignManagers().get(params).$promise.then(function(data) {
                service.users = data.users;
                deferred.resolve();
            }, function(response) {
                console.log("error getting campaign manager users");
                deferred.reject();
            });

            return deferred.promise;
        };

        service.getAllFinanceUsers = function() {
            const deferred = $q.defer();

            IoUserFactory.allFinanceUsers().get().$promise.then(function(data) {
                service.users = data.users;
                deferred.resolve();
            }, function(response) {
                console.log("Error getting finance users");
                deferred.reject();
            });

            return deferred.promise;
        };

        // Get all available submit users
        service.getSubmitUsers = function(clusterId) {
            var deferred = $q.defer();
            var params = {'clusterId': clusterId};

            IoUserFactory.submitUsers().get(params).$promise.then(function(data) {
                service.users = data.users;
                deferred.resolve();
            }, function(response) {
                console.log("error getting submit users");
                deferred.reject();
            });

            return deferred.promise;
        };

        service.updateSubmitUser = function(orderId, userId) {
            var deferred = $q.defer();
            var params = {
                'id': orderId,
                'submitUserId': userId
            };

            IoUserFactory.updateSubmitUser().update(params).$promise.then(function(data) {
                service.userId = data.submitUserId;
                deferred.resolve();
            }, function(response) {
                console.log("error updating submit user");
                deferred.reject();
            });

            return deferred.promise;
        };

        // Get the user role types
        service.getRoleTypes = function() {
            var deferred = $q.defer();

            IoUserFactory.roleTypes().get().$promise.then(function(data) {
                service.roleTypes = data.roleTypes;
                deferred.resolve(data.roleTypes);
            }, function(response) {
                console.log("error getting role types");
                deferred.reject();
            });

            return deferred.promise;
        };

        return service;
    })

    .factory('IoUserFactory', ['$resource', 'AppConfig', function($resource, AppConfig) {
        var factory = {};

        factory.users = function() {
            return $resource(AppConfig.IO_API_URL + 'users', null, {
                'get': {
                    method: 'GET',
                    isArray: false
                }
            });
        };

        factory.user = function() {
            return $resource(AppConfig.IO_API_URL + 'users/user', null, {
                'get': {
                    method: 'GET',
                    isArray: false
                }
            });
        };

        factory.usersForQueue = function() {
            return $resource(AppConfig.IO_API_URL + 'users/usersForQueue', null, {
                'save': {
                    method: 'POST',
                    isArray: false
                }
            });
        };

        factory.usersForQueues = function() {
            return $resource(AppConfig.IO_API_URL + 'users/usersForQueues', null, {
                'save': {
                    method: 'POST',
                    isArray: false
                }
            });
        };

        factory.usersForCluster = function() {
            return $resource(AppConfig.IO_API_URL + 'users/usersForCluster', null, {
                'get': {
                    method: 'GET',
                    isArray: false
                }
            });
        };

        factory.clients = function() {
            return $resource(AppConfig.IO_API_URL + 'users/clients', null, {
                'get': {
                    method: 'GET',
                    isArray: false
                }
            });
        };

        factory.agents = function() {
            return $resource(AppConfig.IO_API_URL + 'users/agents', null, {
                'get': {
                    method: 'GET',
                    isArray: false
                }
            });
        };

        factory.salesAgents = function() {
            return $resource(AppConfig.IO_API_URL + 'users/salesAgents', null, {
                'get': {
                    method: 'GET',
                    isArray: false
                }
            });
        };

        factory.adopsAgents = function() {
            return $resource(AppConfig.IO_API_URL + 'users/adopsAgents', null, {
                'get': {
                    method: 'GET',
                    isArray: false
                }
            });
        };

        factory.clients = function() {
            return $resource(AppConfig.IO_API_URL + 'clients', null, {
                'get': {
                    method: 'GET',
                    isArray: false
                }
            });
        };

        factory.clientStatuses = function() {
            return $resource(AppConfig.IO_API_URL + 'clients/clientStatuses', null, {
                'get': {
                    method: 'GET',
                    isArray: false
                }
            });
        };

        factory.client = function() {
            return $resource(AppConfig.IO_API_URL + 'clients/client', null, {
                'get': {
                    method: 'GET',
                    isArray: false
                },
                'save': {
                    method: 'POST',
                    isArray: false
                },
                'update': {
                    method: 'PUT',
                    isArray: false
                }
            });
        };

        factory.currentUserRole = function() {
            return $resource(AppConfig.IO_API_URL + 'users/loggedInUser', null, {
                'get': {
                    method: 'GET',
                    isArray: false
                }
            });
        };

        factory.getUserTaRolePermissions = function() {
            return $resource(AppConfig.IO_API_URL + 'users/userTaRolePermissions', null, {
                'get': {
                    method: 'GET',
                    isArray: false
                }
            });
        };

        factory.campaignManagers = function() {
            return $resource(AppConfig.IO_API_URL + 'users/campaignManagers', null, {
                'get': {
                    method: 'GET',
                    isArray: false
                }
            });
        };

        factory.allFinanceUsers = function() {
            return $resource(AppConfig.IO_API_URL + 'users/allFinanceUsers', null, {
                'get': {
                    method: 'GET',
                    isArray: false
                }
            });
        };

        factory.submitUsers = function() {
            return $resource(AppConfig.IO_API_URL + 'users/submitUsers', null, {
                'get': {
                    method: 'GET',
                    isArray: false
                }
            });
        };

        factory.updateSubmitUser = function() {
            return $resource(AppConfig.IO_API_URL + 'orders/updateSubmitUser', null, {
                'update': {
                    method: 'PUT',
                    isArray: false
                }
            });
        };

        factory.roleTypes = function() {
            return $resource(AppConfig.IO_API_URL + 'users/roleTypes', null, {
                'update': {
                    method: 'GET',
                    isArray: false
                }
            });
        };

        return factory;
    }]);
